const categories = [
  {
    title: 'SORT',
    options: [
      { label: 'Ascending Rarity', value: 'ascending_rarity' },
      { label: 'Descending Rarity', value: 'descending_rarity' },
    ],
  },
  {
    title: 'RARITY',
    options: [
      { label: '1-1000', value: '1_1000' },
      { label: '1001-2000', value: '1001_2000' },
      { label: '2001-3000', value: '2001_3000' },
      { label: '3001-4000', value: '3001_4000' },
      { label: '4001-5000', value: '4001_5000' },
      { label: '5001-6000', value: '5001_6000' },
      { label: '6001-7000', value: '6001_7000' },
      { label: '7001-8000', value: '7001_8000' },
      { label: '8001-9000', value: '8001_9000' },
      { label: '9001-10000', value: '9001_10000' },
    ],
  },
];

export default categories;